import React, {
  Component,
  useContext,
  useState,
  useRef,
  useEffect,
} from "react";
import { observer } from "mobx-react";
import { MdMoreHoriz, MdDone } from "react-icons/md";
import { ContainerStoreContext, ViewStoreContext } from "../ContainerStore";
import COLORS from "scss/colors.module.scss";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import styled from "styled-components";

function RowDirection(props) {
  const containerStore = React.useContext(ContainerStoreContext);
  const view = containerStore?.view;
  const options = containerStore?.view?.options;
  if (typeof options == "string") {
    options = JSON.parse(options);
  }
  const RowDirectionOption = options.options?.default_sort_direction ?? "ASC";
  const availableDirections = [
    { label: "New Records at the Top", value: "DESC" },
    { label: "New Records at the Bottom", value: "ASC" },
  ];
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setRowDirection = async (value) => {
    if (typeof view.options == "string") {
      view.options = JSON.parse(view.options);
    }
    view.options.options = view.options.options || {};
    view.options.options.default_sort_direction = value;
    props.store.isViewSaving = true;
    const viewAfterSave = await containerStore.saveView(view);
    props.store.isViewSaving = false;
    //containerStore.view = viewAfterSave;
    props.store.refreshData();
    //await containerStore.loadGridAfterViewSave();
  };

  return (
    <>
      <StyledRowDirectionDiv className="d-flex" onClick={handleClick}>
        <MdMoreHoriz size={18} color={COLORS.TEXT_COLOR} />
      </StyledRowDirectionDiv>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {availableDirections.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              setRowDirection(item.value);
              handleClose();
            }}
            selected={RowDirectionOption === item.value}
          >
            {item.label}
            {RowDirectionOption === item.value && (
              <StyledDoneIcon size={18} color={COLORS.TEXT_COLOR} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

const StyledRowDirectionDiv = styled.div`
  margin: 3px;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  align-items: center;
  &:hover {
    background-color: ${COLORS.ACTIONS_HOVER};
  }
`;

const StyledDoneIcon = styled(MdDone)`
  margin-left: 5px;
  align-items: center;
  display: flex;
`;

export default observer(RowDirection);
